module.exports = __webpack_public_path__ + "img/1522976525.04b4ddd5.jpg";